import React from "react";

// Navigate
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { CommissionManageTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

//mui
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Container from "@mui/material/Container";
import Fade from "@mui/material/Fade";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

// Mui Icon
import HelpIcon from "@mui/icons-material/Help";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";

//moment
import { getRosterByUserIdAndDate } from "@/fetch/fetchRoster";
import moment from "moment";

import BonusFormRow from "@/components/CommisstionSetting/bonusFormRow";
import MutiLocationFormRow from "@/components/CommisstionSetting/mutiLocationFormRow";
import ProductBonusFormRows from "@/components/CommisstionSetting/productBonusFormRows";
import ProductCommissionFormRows from "@/components/CommisstionSetting/productCommissionFormRows";
import SpecialShiftFormRows from "@/components/CommisstionSetting/specialShiftFormRows";
import TransferAmountFormRows from "@/components/CommisstionSetting/transferAmountFormRows";
import TransferProductCommissionsFormRows from "@/components/CommisstionSetting/transferProductCommissionsFormRows";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getProducts } from "@/fetch/fetchStatistics";
import _ from "lodash";

import AdjustmentFormRows from "@/components/CommisstionSetting/adjustmentFormRows";
import CommissionLevelFormRows from "@/components/CommisstionSetting/commissionLevelFormRows";
import DirectSalesFormRows from "@/components/CommisstionSetting/directSalesFormRows";
import SpecialCommissionLevelFormRows from "@/components/CommisstionSetting/specialComissionLevelFormRows";
import {
  fetchSetting,
  reset,
  saveSetting,
  setDefaultSetting,
} from "@/features/commissionSlice";
import { useDispatch, useSelector } from "react-redux";
moment.updateLocale("zh-hk", {
  weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
});
const CommissionSettingPage = (props) => {
  const { open, setOpen } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: "none",
    },
  });
  const validations = useSelector((state) => state.commission.validations);
  const currentDate = useSelector(
    (state) => state.commission.settings.currentDate,
  );

  const [productOptions, setProductOptions] = React.useState([]);
  const [promoterOptions, setPromoterOptions] = React.useState([]);
  const [promoterOption, setPromoterOption] = React.useState([]);

  const location = useLocation();
  const mode = location?.state?.mode;
  const disabled = mode === "view" || !mode;
  const fetch = async () => {
    if (id) {
      await dispatch(fetchSetting(id)).unwrap();
    } else {
      dispatch(
        setDefaultSetting({
          date: location.state.date,
        }),
      );
    }
    const { data: promoters } = await getAllPromoter(true);
    const { data: products } = await getProducts(true);
    const sortByStaffCode = _.sortBy(promoters, "staff_code");
    const formattedPromoterOptions = _.map(sortByStaffCode, (promoter) => {
      return {
        label: `${promoter.alias} (${promoter.staff_code})`,
        value: String(promoter.id),
        staff_code: promoter.staff_code,
      };
    });
    setPromoterOption(sortByStaffCode);
    setPromoterOptions(formattedPromoterOptions);

    setProductOptions(products);
    setSlideTranOn(true);
  };
  const handleOnClickSave = async () => {
    setIsLoading(true);
    try {
      await dispatch(saveSetting(id)).unwrap();
      setTimeout(() => navigate("/commission"), 2000);
    } catch (error) {
      console.error("Failed to save commission setting", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleRoster = async (cloneRow, value, date) => {
    const { data: roster } = await getRosterByUserIdAndDate(value, date);
    let rosterString = "";
    let location_id = "";
    if (!roster) {
      rosterString = "沒有設定";
    } else if (roster.is_off) {
      rosterString = roster.off_type;
    } else if (roster.is_leave) {
      rosterString = roster.leave_type;
    } else {
      if (roster.roster === "FULL") {
        rosterString = `${roster.work_name} - 全日更`;
      } else {
        rosterString = `${roster.work_name} - ${roster.roster}更`;
      }
      location_id = roster.location_id;
    }
    cloneRow.rosterString = rosterString;
    cloneRow.location_id = location_id;
    return cloneRow;
  };

  const commissionLevelFormObj = {
    disabled,
  };
  const specialCommissionLevelFormObj = {
    promoterOption,
    disabled,
  };
  const productCommissionsFormObj = {
    productOptions,
    disabled,
  };
  const directSalesFormObj = {
    productOptions,
    disabled,
  };

  const productBonusFormObj = {
    productOptions,
  };
  const specialShiftFormObj = {
    disabled,
    promoterOptions,
    handleRoster,
  };
  const mutiLocationFormObj = {
    promoterOption,
  };
  const bonusFormObj = {
    disabled,
  };
  const transferFormObj = {
    disabled,
    promoterOptions,
    handleRoster,
  };
  const transferProductCommissionsFormObj = {
    disabled,
    promoterOptions,
    handleRoster,
    productOptions,
  };
  const adjustmentFormObj = {
    disabled,
    promoterOptions,
    productOptions,
  };
  const arrForm = [
    {
      name: "commissionLevelForm",
      title: "佣金百份比(預設)",
      tooltip:
        "如果沒有上限，請於最後一層輸入一個無限大銷售金額 例$9,999,999,999",
      component: <CommissionLevelForm {...commissionLevelFormObj} />,
      error: validations.commissionLevels.length > 0,
    },
    {
      name: "specialCommissionLevelForm",
      title: "兼職佣金百份比",
      tooltip: `如無設定兼職員工將會以預設佣金計算
        如果沒有上限，請於最後一層輸入一個無限大銷售金額 例$9,999,999,999`,
      component: (
        <SpecialCommissionLevelForm {...specialCommissionLevelFormObj} />
      ),
      error: validations.specialCommissionLevels.length > 0,
    },
    {
      name: "productCommissionsForm",
      title: "盒仔佣",
      tooltip: `如勾選了「不計入佣金」該時段的銷售額將不計入佣金
      如勾選了「Direct Sales」該產品會以Direct Sales的銷售額作出計算盒仔佣
      如需要分層計算,請按下複製按鈕並設定每層的名稱，最少／最多目標數量和佣金
      如果沒有上限，請於最後一層的「最多目標數量」輸入一個無限大件數 例999,999,999`,
      component: <ProductCommissionsForm {...productCommissionsFormObj} />,
      error: validations.productCommissions.length > 0,
    },
    {
      name: "directSalesForm",
      title: "Direct Sales",
      tooltip: ``,
      component: <DirectSalesForm {...directSalesFormObj} />,
    },
    {
      name: "productBonusForm",
      title: "產品獎金",
      tooltip: `如需要分層計算,請按下複製按鈕並設定每層的名稱，最少／最多目標數量和獎金金額
      如果沒有上限，請於最後一層的「最多目標數量」輸入一個無限大件數 例999,999,999
      如橫跨多個月份計算，請於最後一個月份設定 例如2025-01-22至2025-02-10，請在2月才計算`,
      component: <ProductBonusForm {...productBonusFormObj} />,
      error: validations.productBonus.length > 0,
    },
    {
      name: "bonusForm",
      title: "到數獎金",
      tooltip: "設定到數獎金",
      component: <BonusForm {...bonusFormObj} />,
      error: !_.every(validations.bonus, (b) => !b),
    },
    {
      name: "specialShiftForm",
      title: "特別更設定",
      tooltip: `如設定為特別更，該銷售員當天的銷售數，盒仔佣將不作計算，
      如同日該鋪頭有其他非特別更的銷售員，將會全數歸入該銷售員`,
      component: <SpecialShiftForm {...specialShiftFormObj} />,
      error: validations.specialShifts.length > 0,
    },
    {
      name: "mutiLocationForm",
      title: "走場設定",
      tooltip: `如設定為走場，該銷售員的目標銷售額會根據當天的鋪頭的目標銷售數設定，
      例如KZ鋪於${moment(currentDate).format(
        "YYYY年M月",
      )}的目標銷售額為$1,000,000, 
      走場銷售員在KZ鋪頭每天目標銷售數為$1,000,000 / 30(該月總日數) = $33,333.3`,
      component: <MutiLocationForm {...mutiLocationFormObj} />,
      error: validations.mutiLocations.length > 0,
    },
    {
      name: "transferForm",
      title: "調整銷售金額",
      tooltip: `金額總和必須為$0`,
      component: <TransferForm {...transferFormObj} />,
      error: validations.transferAmounts.length > 0,
    },
    {
      name: "transferProductCommissionsForm",
      title: "調整盒仔佣",
      tooltip: `件數總和必須為$0`,
      component: (
        <TransferProductCommissionsForm
          {...transferProductCommissionsFormObj}
        />
      ),
      error: validations.transferProductCommissions.length > 0,
    },
    {
      name: "adjustmentForm",
      title: "最後調整",
      tooltip: `任意調整，必須輸入備註`,
      component: <AdjustmentForm {...adjustmentFormObj} />,
      error: validations.adjustment.length > 0,
    },
  ];

  const muiAccordion = (forms) => (
    <ThemeProvider theme={CommissionManageTheme}>
      <Container>
        {forms.map(({ title, component, tooltip, name, error }, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography style={{ color: error ? "red" : "black" }}>
                {error && (
                  <IconButton>
                    <ReportProblemIcon color="error"></ReportProblemIcon>
                  </IconButton>
                )}
                {title}
                {tooltip && (
                  <CustomWidthTooltip
                    sx={{ whiteSpace: "pre-line" }}
                    title={
                      <span
                        style={{
                          whiteSpace: "pre-line",
                          fontSize: "14px",
                        }}
                      >
                        {tooltip}
                      </span>
                    }
                    placement="right-end"
                  >
                    <IconButton>
                      <HelpIcon />
                    </IconButton>
                  </CustomWidthTooltip>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>{component}</AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </ThemeProvider>
  );
  React.useEffect(() => {
    fetch();
    return () => {
      dispatch(reset());
    };
  }, []);
  return (
    <Layout header="StaffManagePage" open={open} setOpen={setOpen}>
      <Title
        title={`佣金設定（${moment(currentDate).format("YYYY年M月")}）`}
        history={() => navigate(-1)}
        children={
          !disabled ? (
            <div>
              {/* Save Record */}
              <IconButton
                component="label"
                onClick={handleOnClickSave}
                disabled={isLoading}
              >
                <SaveIcon />
              </IconButton>
            </div>
          ) : null
        }
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>{muiAccordion(arrForm)}</StyledPaper>
      </Fade>
    </Layout>
  );
};

export default CommissionSettingPage;

const CommissionLevelForm = React.memo(function CommissionLevelForm(props) {
  return <CommissionLevelFormRows {...props}></CommissionLevelFormRows>;
});

const SpecialCommissionLevelForm = React.memo(
  function SpecialCommissionLevelForm(props) {
    return (
      <SpecialCommissionLevelFormRows
        {...props}
      ></SpecialCommissionLevelFormRows>
    );
  },
);
const DirectSalesForm = React.memo(function DirectSalesForm(props) {
  return <DirectSalesFormRows {...props}></DirectSalesFormRows>;
});

const ProductCommissionsForm = React.memo(
  function ProductCommissionsForm(props) {
    return <ProductCommissionFormRows {...props} />;
  },
);

const ProductBonusForm = React.memo(function ProductBonusForm(props) {
  return <ProductBonusFormRows {...props}></ProductBonusFormRows>;
});

const MutiLocationForm = React.memo(function MutiLocationForm(props) {
  return <MutiLocationFormRow {...props} />;
});

const BonusForm = React.memo(function BonusForm(props) {
  return <BonusFormRow {...props} />;
});

const TransferProductCommissionsForm = React.memo(
  function TransferProductCommissionsForm(props) {
    return <TransferProductCommissionsFormRows {...props} />;
  },
);

const SpecialShiftForm = React.memo(function SpecialShiftForm(props) {
  return <SpecialShiftFormRows {...props} />;
});

const TransferForm = React.memo(function TransferForm(props) {
  return <TransferAmountFormRows {...props} />;
});

const AdjustmentForm = React.memo(function AdjustmentForm(props) {
  return <AdjustmentFormRows {...props}></AdjustmentFormRows>;
});
